var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment, useContext, useState } from 'react';
import styled, { css } from 'styled-components';
import { TargettedSystemContext, TargettedSystems } from '../..';
import WindowDispatchContext from '../../context/window-dispatch-context';
import WindowEventContext from '../../context/window-event-context';
import WindowStateContext from '../../context/window-state-context';
import WindowUpdateContentContext from '../../context/window-update-content-context';
import { blinkingAnimation, convertToCSSValue, getGeometryStyle, getHeightWidth, getMaximumHeight, getMaximumWidth, getMinimumHeight, getMinimumWidth, } from '../../helpers/styles';
import useFormItem from '../../hooks/useFormItem';
import CaptureBTWidget from '../CaptureBTWidget';
import ChildItemWidget from '../ChildItemWidget';
export var getMinHeightWidth = function (minimumSize) {
    return "\n  min-height: " + getMinimumHeight(minimumSize) + ";\n  min-width: " + getMinimumWidth(minimumSize) + ";";
};
export var getMaxHeightWidth = function (maximumSize) {
    return "\n  max-height: " + getMaximumHeight(maximumSize) + ";\n  max-width: " + getMaximumWidth(maximumSize) + ";";
};
export var getMarginLeft = function (marginLeft) {
    return "\n  margin-left: " + convertToCSSValue(marginLeft) + ";\n  ";
};
export var getMarginRight = function (marginRight) {
    return "\n  margin-right: " + convertToCSSValue(marginRight) + ";\n  ";
};
export var getMarginTop = function (marginTop) {
    return "\n  margin-top: " + convertToCSSValue(marginTop) + ";\n  ";
};
export var getMarginBottom = function (marginBottom) {
    return "\n  margin-left: " + convertToCSSValue(marginBottom) + ";\n  ";
};
var StyledButton = styled.button.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  margin: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  color: ", ";\n  border: ", ";\n  background: ", ";\n  outline: ", ";\n  box-sizing: ", ";\n  border-radius: ", ";\n  cursor: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  border-left-color: ", ";\n  border-top-color: ", ";\n  border-right-color: ", ";\n  border-bottom-color: ", ";\n  background-color: ", ";\n  ", "\n  :focus {\n    outline: ", ";\n  }\n  :active {\n    border-left-color: ", ";\n    border-top-color: ", ";\n    border-right-color: ", ";\n    border-bottom-color: ", ";\n  }\n  :hover {\n    background-color: ", ";\n  }\n"], ["\n  ", "\n  ",
    "\n  ", "\n  ", "\n  margin: ",
    ";\n  ",
    "\n  ",
    "\n  ",
    "\n  ",
    "\n  color: ",
    ";\n  border: ", ";\n  background: ", ";\n  outline: ", ";\n  box-sizing: ", ";\n  border-radius: ", ";\n  cursor: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  border-left-color: ",
    ";\n  border-top-color: ", ";\n  border-right-color: ",
    ";\n  border-bottom-color: ",
    ";\n  background-color: ",
    ";\n  ",
    "\n  :focus {\n    outline: ", ";\n  }\n  :active {\n    border-left-color: ",
    ";\n    border-top-color: ",
    ";\n    border-right-color: ",
    ";\n    border-bottom-color: ",
    ";\n  }\n  :hover {\n    background-color: ",
    ";\n  }\n"])), function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return getHeightWidth(windowTheme.button.width, windowTheme.button.height);
}, function (_a) {
    var minimumSize = _a.minimumSize;
    return minimumSize && getMinHeightWidth(minimumSize);
}, function (_a) {
    var maximumSize = _a.maximumSize;
    return maximumSize && getMaxHeightWidth(maximumSize);
}, function (_a) {
    var windowTheme = _a.windowTheme, attributes = _a.attributes;
    return attributes.hasOwnProperty('margin')
        ? convertToCSSValue(attributes.margin)
        : windowTheme.button.margin;
}, function (_a) {
    var attributes = _a.attributes;
    return attributes.marginLeft && getMarginLeft(attributes.marginLeft);
}, function (_a) {
    var attributes = _a.attributes;
    return attributes.marginRight && getMarginRight(attributes.marginRight);
}, function (_a) {
    var attributes = _a.attributes;
    return attributes.marginTop && getMarginTop(attributes.marginTop);
}, function (_a) {
    var attributes = _a.attributes;
    return attributes.marginBottom && getMarginBottom(attributes.marginBottom);
}, function (_a) {
    var windowTheme = _a.windowTheme, fontColor = _a.fontColor;
    return fontColor !== null && fontColor !== void 0 ? fontColor : windowTheme.button.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.background;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.outline;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.boxSizing;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderRadius;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.cursor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.fontFamily;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme.label) === null || _b === void 0 ? void 0 : _b.fontSize;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme.label) === null || _b === void 0 ? void 0 : _b.fontWeight;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderColor.left;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderColor.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderColor.right;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderColor.bottom;
}, function (_a) {
    var windowTheme = _a.windowTheme, backgroundColor = _a.backgroundColor, toggleStatus = _a.toggleStatus;
    return toggleStatus
        ? windowTheme.button.toggleOnColor
        : backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : windowTheme.button.backgroundColor;
}, function (_a) {
    var windowTheme = _a.windowTheme, backgroundColor = _a.backgroundColor, blinkingTime = _a.blinkingTime;
    return backgroundColor &&
        blinkingTime && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      animation: ", "\n        ", "s infinite;\n    "], ["\n      animation: ",
        "\n        ", "s infinite;\n    "])), blinkingAnimation(backgroundColor, windowTheme.textInput.backgroundColor), blinkingTime);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.focus.outline;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.active.borderColor.left;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.active.borderColor.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.active.borderColor.right;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.active.borderColor.bottom;
}, function (_a) {
    var windowTheme = _a.windowTheme, toggleStatus = _a.toggleStatus, backgroundColor = _a.backgroundColor;
    return toggleStatus
        ? windowTheme.button.toggleOnColor
        : backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : windowTheme.button.hover.backgroundColor;
});
var getText = function (props) {
    var Text1 = props.Text1, Text2 = props.Text2;
    return Text1 || Text2 ? Text1 + '\n' + Text2 : '';
};
var Button = function (props) {
    var _a;
    var _b = useContext(WindowEventContext), _onButtonClick = _b._onButtonClick, _onBTCapture = _b._onBTCapture, _onToggleButtonClick = _b._onToggleButtonClick;
    var windowId = props.windowId, attributes = props.attributes, identifier = props.identifier, form = props.form, type = props.type, system = props.system, className = props.className, _c = props.isToggleButton, isToggleButton = _c === void 0 ? false : _c, _d = props.contentButton, contentButton = _d === void 0 ? false : _d, restProps = __rest(props, ["windowId", "attributes", "identifier", "form", "type", "system", "className", "isToggleButton", "contentButton"]), text = attributes.text, Image = attributes.Image, geometry = attributes.geometry, minimumSize = attributes.minimumSize, maximumSize = attributes.maximumSize, enabled = attributes.enabled;
    var _e = useFormItem(identifier).value, value = _e === void 0 ? false : _e;
    var targetSystem = useContext(TargettedSystemContext);
    var _f = useState(false), showCaptureBT = _f[0], setShowCaptureBT = _f[1];
    var stateFromEnv = useContext(WindowStateContext);
    var isCaptureBTButton = text === 'Capture BT';
    var valuesFromEnv = stateFromEnv.fields;
    var fontColor = valuesFromEnv[identifier + "_fontColor"];
    var blinkingTime = valuesFromEnv[identifier + "_blinkingTime"];
    var backgroundColor = (_a = valuesFromEnv[identifier + "_backgroundColor"]) !== null && _a !== void 0 ? _a : (stateFromEnv.focusedButton === identifier ? '#70809B' : null);
    var updateContext = useContext(WindowUpdateContentContext);
    var dispatch = useContext(WindowDispatchContext);
    var handleClick = function () {
        if (isCaptureBTButton) {
            setShowCaptureBT(true);
        }
        else if (isToggleButton) {
            _onToggleButtonClick(identifier, !value);
        }
        else {
            if (attributes.hasOwnProperty('data-item') &&
                attributes['data-item'] === 'childContext' &&
                stateFromEnv.focusedButton !== identifier) {
                dispatch(updateContext(identifier));
            }
            _onButtonClick(identifier);
        }
    };
    var onSelectBT = function (obj) {
        _onBTCapture(identifier, {
            latV: "" + obj.latV,
            latH: obj.latH,
            longV: "" + obj.longV,
            longH: obj.longH,
        });
        setShowCaptureBT(false);
    };
    var handleCloseCaptureBT = function () {
        setShowCaptureBT(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledButton, __assign({ id: identifier, "data-widget-type": type, geometry: geometry }, restProps, { onClick: handleClick, minimumSize: minimumSize, maximumSize: maximumSize, disabled: (enabled && enabled === 'false') || false, attributes: attributes, fontColor: fontColor, backgroundColor: backgroundColor, toggleStatus: isToggleButton && value, blinkingTime: blinkingTime }), contentButton ? (React.createElement(ChildItemWidget, __assign({}, props))) : targetSystem === TargettedSystems.HERMESYS ? (React.createElement(HermesysButtonContent, { Image: Image, text: text, attributes: attributes })) : (React.createElement(Content, { Image: Image, text: text, attributes: attributes }))),
        isCaptureBTButton && (React.createElement(CaptureBTWidget, { buttonId: identifier, open: showCaptureBT, onPointConfirm: onSelectBT, handleClose: handleCloseCaptureBT }))));
};
var Content = function (_a) {
    var Image = _a.Image, text = _a.text, attributes = _a.attributes;
    return (React.createElement(Fragment, null, Image ? (React.createElement("img", { height: 25, width: 25, src: require("../../assets/icons/" + Image.replace(/:/g, '') + ".png") })) : (text || getText(attributes))));
};
var HermesysButtonContent = function (_a) {
    var Image = _a.Image, text = _a.text, attributes = _a.attributes;
    return (React.createElement(StyledHermesysButtonContent, null,
        Image && (React.createElement("img", { height: 25, width: 25, src: require("../../assets/icons/" + Image.replace(/:/g, '') + ".png") })),
        text || getText(attributes)));
};
export var StyledHermesysButtonContent = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n"])));
export default Button;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map